import { useMemo } from "react";

import { useGetLogsNames } from "~/entity/Logs";
import {
  FilterFieldOption,
  FilterFieldOptionsHookResult,
} from "~/features/filter";
import { formaterLogNames } from "~/pages/Logs/IntegrationsLogs/helper";

/**
 * Опции фильтра «Наименование события»: имена крон-задач с GET /logs/cron/names.
 * value совпадает с label — в API уходит само название (параметр `name`).
 */
export const useCronLogNameOptions = (): FilterFieldOptionsHookResult => {
  const { data, isLoading } = useGetLogsNames();

  const options = useMemo<FilterFieldOption[]>(
    () => (data?.length ? formaterLogNames(data) : []),
    [data],
  );

  return { options, loading: isLoading };
};
